"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JWTWriter = exports.JWTReader = void 0;
var RSA_1 = __importDefault(require("./RSA"));
var TokenValidator_1 = __importStar(require("./TokenValidator"));
var TokenFormat_1 = require("./TokenFormat");
var JWTReader = /** @class */ (function () {
    function JWTReader(raw, typ) {
        if (typ === void 0) { typ = 'JWT'; }
        this.validator = new TokenValidator_1.default(raw, 3);
        var _a = this.validator.verify_format(), valid = _a[0], errors = _a[1];
        if (!valid && errors.includes(TokenValidator_1.ValidationError.InvalidSegmentCount)) {
            throw new Error('Invalid token');
        }
        if (!this.validator.header.typeMatches(typ, false)) {
            throw new Error("type missmatch, expecting ".concat(typ, ", got ").concat(this.validator.header.typ));
        }
        this.body = new TokenFormat_1.Body(this.validator.at(1));
    }
    JWTReader.prototype.verify = function (pub, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validator.verify(pub, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Object.defineProperty(JWTReader.prototype, "kid", {
        get: function () {
            return this.header && 'kid' in this.header ? this.header.kid : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JWTReader.prototype, "signature", {
        get: function () {
            return this.validator.at(2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JWTReader.prototype, "header", {
        get: function () {
            return this.validator.header;
        },
        enumerable: false,
        configurable: true
    });
    JWTReader.prototype.signature_matches = function (pub) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validator.signature_matches(pub)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return JWTReader;
}());
exports.JWTReader = JWTReader;
exports.default = JWTReader;
var JWTWriter = /** @class */ (function () {
    function JWTWriter(body) {
        this._body = body;
    }
    JWTWriter.prototype.sign = function (prv) {
        return __awaiter(this, void 0, void 0, function () {
            var unsigned_token, signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        unsigned_token = (0, TokenFormat_1.encode)({
                            alg: 'RS256',
                            typ: 'JWT',
                            kid: prv.keyid,
                        }) +
                            '.' +
                            (0, TokenFormat_1.encode)(this._body);
                        return [4 /*yield*/, RSA_1.default.sign(prv, unsigned_token)];
                    case 1:
                        signature = _a.sent();
                        return [2 /*return*/, unsigned_token + '.' + signature];
                }
            });
        });
    };
    return JWTWriter;
}());
exports.JWTWriter = JWTWriter;
